import styles from "../mainRedesign.module.scss";

const features = [
  {
    icon: "architecture",
    title: "설계내역 작성",
    desc: "원가계산서, 내역서를 일위대가/단가산출/자재단가/노임단가/기계경비 기준으로 작성합니다.",
    benefits: ["표준품셈/물가자료 연동", "자동 원가계산서 생성", "엑셀 3일 → 30분~1시간"],
  },
  {
    icon: "table_chart",
    title: "엑셀 자동화",
    desc: "작성된 내역서를 기반으로 계약, 기성, 변경, 준공 서류를 자동 생성합니다.",
    benefits: ["계약/기성/변경/준공 서류", "10초 내 서류 완성", "엑셀 다운로드 지원"],
  },
  {
    icon: "straighten",
    title: "물량산출",
    desc: "CAD 도면 일부를 복사·붙여넣기하면 길이, 면적, 수량을 자동 산출하여 내역서에 반영합니다.",
    benefits: ["CAD 도면 인식", "길이/면적/수량 산출", "복사·붙여넣기로 간편 입력"],
    badge: "준비중",
  },
];

const comparisons = [
  { task: "설계내역서 작성", old: "엑셀 수작업 3일", now: "30분~1시간" },
  { task: "계약/기성/변경/준공 서류", old: "수작업 2일", now: "자동 생성 10초" },
  { task: "물량산출", old: "수작업 측정 수일", now: "도면 붙여넣기 자동 산출", badge: "준비중" },
  { task: "단가/품셈 검색", old: "책자/PDF 수동 검색", now: "DB 검색 즉시" },
];

export default () => {
  return (
    <section className={styles.aiSection}>
      <div className={styles.sectionInner}>
        <div className={styles.aiSectionHeader}>
          <h2 className={styles.sectionTitle}>
            엑셀 수작업, 이제 그만
          </h2>
          <p className={styles.sectionSubtitle}>
            콘엑스 하나로 설계내역 작성부터 엑셀 공무까지
          </p>
        </div>

        <div className={styles.featuresGrid}>
          {features.map((f) => (
            <div key={f.title} className={styles.featureCard}>
              {"badge" in f && f.badge && (
                <span className={`${styles.serviceBadge} ${styles.isNew}`}>{f.badge}</span>
              )}
              <div className={styles.featureIconWrap}>
                <span className="material-symbols-outlined">{f.icon}</span>
              </div>
              <h3 className={styles.featureTitle}>{f.title}</h3>
              <p className={styles.featureDescription}>{f.desc}</p>
              <div className={styles.featureBenefits}>
                {f.benefits.map((b) => (
                  <div key={b} className={styles.benefit}>
                    <span className={`material-symbols-outlined ${styles.benefitIcon}`}>check_circle</span>
                    {b}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.comparisonCards}>
          {comparisons.map((item) => (
            <div key={item.task} className={styles.comparisonItem}>
              <div className={styles.comparisonTask}>
                {item.task}
                {"badge" in item && item.badge && (
                  <span className={`${styles.serviceBadge} ${styles.isNew}`} style={{ position: "static", marginLeft: 6, fontSize: 11, verticalAlign: "middle" }}>{item.badge}</span>
                )}
              </div>
              <div className={styles.comparisonValues}>
                <div className={styles.comparisonOld}>
                  <span className={styles.comparisonLabel}>기존</span>
                  {item.old}
                </div>
                <div className={styles.comparisonArrow}>
                  <span className="material-symbols-outlined" style={{ fontSize: 18 }}>arrow_forward</span>
                </div>
                <div className={styles.comparisonNew}>
                  <span className={styles.comparisonLabel}>콘엑스</span>
                  {item.now}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.comparisonSummary}>
          <span className={styles.summaryOld}>평균 3일 이상</span>
          <span className="material-symbols-outlined" style={{ fontSize: 20, color: "#9ca3af" }}>trending_flat</span>
          <span className={styles.summaryNew}>1시간 이내</span>
        </div>
      </div>
    </section>
  );
};
